import BroadcastTVControl from './BroadcastTVControl';
import CitiesControl from './CitiesControl';
import ClusterSalesControl from './ClusterSalesControl';
import CompetitorsControl from './CompetitorsControl';
import CustomersControl from './CustomersControl';
import DealershipsControl from './DealershipsControl';
import StoresMotocycleControl from './StoresMotocycleControl';
import StoresConsortiumControl from './StoresConsortiumControl';
import StoreInactiveControl from './StoreInactiveControl';
import UnapprovedStoresControl from './UnapprovedStoresControl';
import DirectSalesControl from './DirectSalesControl';
import DncFlexibleControl from './DncFlexibleControl';
import GreenfieldControl from './GreenfieldControl';
import NewGreenfieldControl from './NewGreenfieldControl';
import BrownfieldControl from './BrownfieldControl';
import MapsControl from './MapsControl';
import MarkedAreaControl from './MarkedAreaControl';
import PGTSControl from './PGTSControl';
import PointOfInterestControl from './PointOfInterestControl';
import ReportControl from './ReportControl';
import RetentionControl from './RetentionControl';
import SelectedAreasControl from './SelectedAreasControl';
import AreaClientControl from './AreaClientControl';
import ServiceAreaControl from './ServiceAreaControl';
import VoronoiControl from './VoronoiControl';
import TollControl from './TollControl';
import FuelStationControl from './FuelStationControl';
import FarmMachineControl from './FarmMachineControl';
import WorkshopPartControl from './WorkshopPartControl';
import StorePlannedControl from './StorePlannedControl.js';
import MallCentersControl from './MallCentersControl.js';

// After Sales
import NetworkAfterSalesControl from './AfterSales/NetworkAfterSalesControl';
import CompetitorsAfterSalesControl from './AfterSales/CompetitorsAfterSalesControl';
import CustomersAfterSalesControl from './AfterSales/CustomersAfterSalesControl';
import StoreAreasAfterSalesControl from './AfterSales/StoreAreasAfterSalesControl';
import MarkedAreaAfterSalesControl from './AfterSales/MarkedAreaAfterSalesControl';
import MulticriteriaAfterSalesControl from './AfterSales/MulticriteriaAfterSalesControl';
import SelectedAreasAfterSalesControl from './AfterSales/SelectedAreasAfterSalesControl';
import ClientSalesAfterSalesControl from './AfterSales/ClientSalesAfterSalesControl';
import DealershipAfterSalesControl from './AfterSales/DealershipAfterSalesControl';
import CompanyCustomersPotentialAfterSalesControl from './AfterSales/CompanyCustomersPotentialAfterSalesControl';
import StoreInactiveAfterSalesControl from './AfterSales/StoreInactiveAfterSalesControl';
import ServiceAreaAfterSalesControl from './AfterSales/ServiceAreaAfterSalesControl';

const features = {
    NetworkAfterSalesControl,
    CompetitorsAfterSalesControl,
    CustomersAfterSalesControl,
    StoreInactiveAfterSalesControl,
    StoreAreasAfterSalesControl,
    MarkedAreaAfterSalesControl,
    MulticriteriaAfterSalesControl,
    SelectedAreasAfterSalesControl,
    ClientSalesAfterSalesControl,
    DealershipAfterSalesControl,
    UnapprovedStoresControl,
    CompanyCustomersPotentialAfterSalesControl,
    ServiceAreaAfterSalesControl,
    MallCentersControl,

    // Montadoras
    BroadcastTVControl,
    CitiesControl,
    ClusterSalesControl,
    CompetitorsControl,
    CustomersControl,
    DealershipsControl,
    StoresMotocycleControl,
    StoresConsortiumControl,
    StoreInactiveControl,
    DirectSalesControl,
    DncFlexibleControl,
    GreenfieldControl,
    NewGreenfieldControl,
    BrownfieldControl,
    MapsControl,
    MarkedAreaControl,
    PGTSControl,
    PointOfInterestControl,
    ReportControl,
    RetentionControl,
    SelectedAreasControl,
    AreaClientControl,
    ServiceAreaControl,
    VoronoiControl,
    TollControl,
    FuelStationControl,
    FarmMachineControl,
    WorkshopPartControl,
    StorePlannedControl,
};

export const get = (name) => {
    let result = features[`${name}Control`] && features[`${name}Control`].getInstance();
    return result;
};

export default features;



// WEBPACK FOOTER //
// ./src/scripts/controls/index.js